<template>
  <div class="comp-container" :class="{ 'comp-container__h5': isH5 }">
    <div class="back" @click="goBack">
      <img :src="arrowLeftImg" alt="" />返回
    </div>
    <div class="code-content">
      <div class="title">
        <h3>输入手机号验证码</h3>
        <p v-show="!verifyRes">
          请输入发送至
          <strong
            ><span>{{ showPhone }}</span></strong
          >
          的6位验证码，有效期5分钟
        </p>
        <p v-show="verifyRes">{{ verifyRes }}</p>
      </div>
      <div class="code-container">
        <input-num
          ref="inputNum"
          :disabled="isVerifying || isLoadingQRCode"
          :default-value="defaultCode"
          @inputOver="inputOver"
        />
        <el-button
          class="refresh-btn"
          :class="{ 'refresh-btn-disabled': !!timeNum }"
          type="text"
          :loading="isLoadingQRCode"
          :disabled="!!timeNum || isLoadingQRCode || isVerifying"
          @click="refreshQRCode"
        >
          {{ refreshText }}
        </el-button>
        <br />
      </div>
    </div>
    <div class="footer">
      <!-- <el-button
        type="primary"
        class="next-step"
        :disabled="nextStepDisabled"
        @click="nextStep"
        >下一步</el-button
      > -->
    </div>
  </div>
</template>

<script>
import ManMachineVerify from "@saas/components/src/mixins/manMachineVerify";
import Login from "@saas/components/src/mixins/login";
import InputNum from "./InputNum";
import { mapState } from "vuex";
import { isH5 } from "@saas/components/src";
export default {
  components: {
    InputNum,
  },
  mixins: [ManMachineVerify, Login],
  props: {
    // login 登录 register 注册
    type: {
      type: String,
      default: "login",
    },
  },
  data() {
    return {
      arrowLeftImg: require("../../../assets/images/login/arrow-left.png"),
      // 验证结果
      verifyRes: "",
      // 是否验证中
      isVerifying: false,
      code: "",
      // 是否请求验证码中
      isLoadingQRCode: false,
      timer: null,
      timeNum: 60,
      defaultCode: ["", "", "", "", "", ""],
      isH5: isH5(),
      //   returnUrl: null
    };
  },
  computed: {
    ...mapState("user", ["loginForm"]),
    nextStepDisabled() {
      return this.code.length !== 6;
    },
    refreshText() {
      return this.timeNum
        ? `${this.timeNum}秒后可重新获取验证码`
        : "重新获取验证码";
    },
    showPhone() {
      // 中间四位
      const num = this.loginForm.mobile;
      return num.replace(/(\d{3})\d{4}(\d{4})/, "$1****$2");
    },
  },
  mounted() {
    this.startTimer();
    // this.returnUrl = this.$route.query.return_url || ''
  },
  methods: {
    startTimer() {
      this.timer = setInterval(() => {
        if (this.timeNum > 0) {
          this.timeNum--;
        } else {
          clearInterval(this.timer);
          this.timer = null;
        }
      }, 1000);
    },
    nextStep() {
      this.isVerifying = true;
      if (this.type === "login") {
        // 验证码登录
        this.$store
          .dispatch("user/loginByCode", {
            account: this.loginForm.mobile,
            region_num: this.loginForm.region_num
              ? this.loginForm.region_num + ""
              : "",
            code: this.code,
          })
          .then(({ code, message }) => {
            this.isVerifying = false;
            this.code = "";
            this.$refs["inputNum"].resetEmpty();
            if (code === 1) {
              this.checkIdentity().then((isIdentity) => {
                if (isIdentity) {
                  this.loginSuccess();
                  this.$message.success("登录成功");
                } else {
                  this.$emit("goSelectIdentity");
                }
              });
            } else if (code === 20005 || code === 20003) {
              this.verifyRes = message;
            } else if (code === 20000) {
              // 用户不存在
              this.$emit("accountNotExist");
            }
          })
          .catch(() => {
            this.isVerifying = false;
          });
      } else {
        this.checkVerifyCode();
      }
    },
    // 注册前校验验证码
    checkVerifyCode() {
      this.$store
        .dispatch("user/checkVerifyCode", {
          account: this.loginForm.mobile,
          code: this.code,
          scene: "QuickLogin",
          scene_str: this.loginForm.sceneStr,
        })
        .then((res) => {
          this.isVerifying = false;
          if (res.code === 1) {
            // 代表已注册过
            if (res.data.access_token && res.data.refresh_token) {
              this.checkIdentity().then((isIdentity) => {
                if (isIdentity) {
                  this.loginSuccess();
                } else {
                  this.$emit("goSelectIdentity");
                }
              });
            } else {
              this.$emit("accountNotExist");
            }
          } else if (res.code === 20005 || res.code === 20004) {
            // 验证码已使用或者过期
            this.$message.error(res.message);
            this.$emit("codeError");
          } else if (res.code === 20003) {
            this.$message.error("验证码错误, 请重新输入");
          }
        })
        .catch(() => {
          this.isVerifying = false;
        });
    },
    inputOver(val) {
      this.code = val;
      //   this.isVerifying = true
      this.$store.commit("user/SET_LOGIN_FORM", {
        mobile: this.loginForm.mobile,
        code: this.code,
      });
      this.nextStep();
    },
    // 人机验证回调
    captchaCallback(res) {
      try {
        if (res.ret === 0) {
          this.sendVerifyCode(res);
        } else {
          console.log(res);
        }
      } catch (error) {
        console.log(error);
      }
    },
    // 发送验证码
    sendVerifyCode(res) {
      this.$store
        .dispatch("user/sendCode", {
          account: this.loginForm.mobile,
          region_num: this.loginForm.region_num
            ? this.loginForm.region_num + ""
            : "",
          randstr: res.randstr,
          scene: "QuickLogin",
          ticket: res.ticket,
        })
        .then((res) => {
          if (res.code === 1) {
            this.timeNum = 60;
            this.startTimer();
          }
          this.isLoadingQRCode = false;
        })
        .catch(() => {
          this.isLoadingQRCode = false;
        });
    },
    // 重新获取验证码
    refreshQRCode() {
      this.isLoadingQRCode = true;
      this.$refs["inputNum"].resetEmpty();
      this.showCaptcha();
    },
    // 切换密码验证
    switchPasswordVerigy() {},
    goBack() {
      this.$emit("back");
    },
  },
};
</script>

<style lang="scss" scoped>
.comp-container {
  width: 480px;
  height: 550px;
  position: relative;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  padding: 55px 0 50px 48px;
  background: #ffffff;
  box-shadow: 0px 2px 10px 0px rgba(156, 175, 154, 0.17);
  border-radius: 24px;
  .back {
    display: flex;
    align-items: center;
    cursor: pointer;
    font-size: 16px;
    color: #515350;
    line-height: 22px;
    img {
      display: inline-block;
      width: 16px;
      height: 16px;
      margin-right: 3px;
    }
  }
  .code-content {
    flex: 1;
    margin: 0;
    margin-top: 16px;
    .title {
      h3 {
        font-weight: 500;
        margin: 0;
        font-size: 24px;
        color: $saas-text-color;
        line-height: 33px;
      }
      p {
        font-weight: 400;
        font-size: 16px;
        color: #515350;
        line-height: 22px;
        height: 22px;
        margin-top: 8px;
        &:last-child {
          color: #f03349;
        }
        span {
          color: rgba(13, 20, 0, 1);
          font-weight: normal;
        }
      }
    }
    .code-container {
      margin-top: 30px;
      padding-right: 48px;
      .refresh-btn {
        font-weight: normal;
        font-size: 14px;
        margin-top: 16px;
        color: rgba(0, 200, 157, 1);
      }
      .refresh-btn-disabled {
        color: #515350;
      }
      .el-button {
        margin-bottom: 8px;
        padding: 5px 0;
      }
    }
  }
  .footer {
    width: 100%;
    padding-right: 48px;
    .next-step {
      width: 100%;
      height: 50px;
      border-radius: 16px !important;
      border: none;
      font-weight: 600;
      font-size: 16px;
      background: linear-gradient(
        132deg,
        rgba(0, 235, 129, 1) 0%,
        rgba(0, 200, 157, 1) 100%
      ) !important;
      color: #fff !important;
      &:hover {
        background: linear-gradient(
          132deg,
          rgba(0, 235, 129, 1) 0%,
          rgba(0, 200, 157, 1) 100%
        ) !important;
        color: #fff !important;
      }
      &:focus {
        color: #fff !important;
        background: linear-gradient(
          132deg,
          rgba(0, 235, 129, 1) 0%,
          rgba(0, 200, 157, 1) 100%
        ) !important;
      }
      &.is-disabled {
        color: #fff !important;
        background: linear-gradient(
          132deg,
          rgba(0, 235, 129, 0.5) 0%,
          rgba(0, 200, 157, 0.5) 100%
        ) !important;
        &:hover {
          color: #fff !important;
          background: linear-gradient(
            132deg,
            rgba(0, 235, 129, 0.5) 0%,
            rgba(0, 200, 157, 0.5) 100%
          ) !important;
        }
        &:focus {
          color: #fff !important;
          background: linear-gradient(
            132deg,
            rgba(0, 235, 129, 0.5) 0%,
            rgba(0, 200, 157, 0.5) 100%
          ) !important;
        }
      }
    }
  }
}
.comp-container__h5 {
  width: 100%;
  height: 100%;
  padding: 0.3067rem 0 0.6667rem 0.64rem;
  box-shadow: none;
  border-radius: 0;
  .back {
    position: absolute;
    left: 0.5067rem;
    top: 0.4rem;
    font-size: 0.4267rem;
    line-height: 0.6rem;
    img {
      width: 0.4267rem;
      height: 0.4267rem;
      margin-right: 0.16rem;
    }
  }
  .code-content {
    margin: 0;
    margin-top: 2.4rem;
    .title {
      h3 {
        font-size: 0.5333rem;
        line-height: 0.7467rem;
      }
      p {
        font-size: 0.3467rem;
        line-height: 0.4933rem;
        height: 0.4933rem;
        margin-top: 0.2667rem;
      }
    }
    .code-container {
      margin-top: 1.2rem;
      padding-right: 0.6667rem;
      .refresh-btn {
        margin-top: 0.4rem;
        font-size: 0.3467rem;
      }
      .el-button {
        margin-bottom: 1.3867rem;
      }
    }
  }
  .footer {
    width: 100%;
    padding-right: 0.6667rem;
    .next-step {
      width: 100%;
      height: 1.3333rem;
      font-size: 0.4267rem;
      border-radius: 0.4267rem !important;
    }
  }
}

@keyframes identifier {
  from {
    transform: rotate(0deg);
  }

  to {
    transform: rotate(360deg);
  }
}
</style>
